export default __webpack_public_path__ + "static/media/CD.f6335ccc.svg";